import { Component, OnInit } from '@angular/core';
import { ClientsService } from 'src/app/services/clients.service';
import {PageEvent, MatPaginatorModule} from '@angular/material/paginator';
import { Router } from '@angular/router';

interface clients {
  name : string;
  units:any;
  phone_number : string;
}


@Component({
  selector: 'app-main-family',
  templateUrl: './main-family.component.html',
  styleUrls: ['./main-family.component.css']
})
export class MainFamilyComponent implements OnInit {
  curent_page = 0
  pageIndex = 0
  page_size = 50

  clients: any
  constructor(private clientServ : ClientsService , private route : Router){}
  ngOnInit(){
    this.init_data()
  }

  init_data(){
    this.clientServ.all_unvirfyClient(this.curent_page,this.page_size).subscribe((res:any) => {
      console.log(res)
      this.clients = res
    })
  }
  handlePageEvent(e: PageEvent) {
    this.pageIndex = e.pageIndex
    this.curent_page = e.pageIndex + 1
    this.page_size = e.pageSize
    this.init_data()
    console.log(e)
  }

  user_details(item:any){
    localStorage.setItem('user_family',JSON.stringify(item))
    this.route.navigate(['pages/family_user_info',item.name])
  }

  goToUnit(name:any){
    this.route.navigate(['pages/unit_details', name])
  }

}
